const PlayStoreIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2001 15.4004L3.97461 27.1612C4.10066 27.608 4.32718 28.02 4.63687 28.3658C4.94656 28.7116 5.33121 28.982 5.76141 29.1563C6.19162 29.3307 6.65599 29.4043 7.11903 29.3717C7.58208 29.3391 8.03153 29.201 8.43303 28.968L21.0638 21.7743L15.2001 15.4004Z"
        fill="#EA4335"
      />
      <path
        d="M26.5505 13.4009L21.0883 10.2725L14.9402 15.6677L21.1134 21.7573L26.5337 18.6623C27.014 18.4109 27.4162 18.0328 27.6968 17.5691C27.9775 17.1054 28.1258 16.5736 28.1258 16.0316C28.1258 15.4896 27.9775 14.9578 27.6968 14.4941C27.4162 14.0304 27.014 13.6523 26.5337 13.4009H26.5505Z"
        fill="#FBBC04"
      />
      <path
        d="M3.97443 4.84766C3.90658 5.09851 3.87282 5.35735 3.87406 5.61721V26.3953C3.87474 26.655 3.90847 26.9136 3.97443 27.1648L15.5847 15.7051L3.97443 4.84766Z"
        fill="#4285F4"
      />
      <path
        d="M15.2838 16.0047L21.0889 10.2749L8.47485 3.0477C8.00031 2.76978 7.46058 2.62258 6.91064 2.6211C6.24646 2.61978 5.60007 2.83568 5.07 3.23588C4.53993 3.63607 4.15525 4.19862 3.97461 4.83776L15.2838 16.0047Z"
        fill="#34A853"
      />
    </svg>
  )
}

export default PlayStoreIcon
